
// ❗❗❗❗❗❗❗❗❗❗❗❗❗❗❗
//        AUTOGENERATED FILE
// ❗❗❗❗❗❗❗❗❗❗❗❗❗❗❗


import React from 'react'
import { ReactComponent as IconSVG } from '../../../assets/icons/ui/arrows/type-1/down.svg'

export const ArrowsType1DownIcon = (props) => {
  return <IconSVG {...props} />  
}

export default ArrowsType1DownIcon
